import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getSingleLoginTemplate } from "../../redux/actions/loginTemplateAction";
import axios from "axios"; // Import axios for making HTTP requests
import Temp1 from "./temp1";
import Temp2 from "./temp2";
import Temp3 from "./temp3"; // Added support for a third template
import { base_url } from "../../Config/Constant";

// Function to get device information
const getDeviceInfo = () => {
  const userAgent = navigator.userAgent;
  
  // Detect device type
  const isMobile = /mobile|android|iphone|ipad|ipod/i.test(userAgent.toLowerCase());
  
  // Detect browser
  const browser = 
    userAgent.includes('Chrome') ? 'Chrome' :
    userAgent.includes('Firefox') ? 'Firefox' :
    userAgent.includes('Safari') ? 'Safari' :
    userAgent.includes('Edge') ? 'Edge' :
    userAgent.includes('MSIE') || userAgent.includes('Trident') ? 'Internet Explorer' :
    'Unknown';
  
  // Detect OS
  const os = 
    userAgent.includes('Windows') ? 'Windows' :
    userAgent.includes('Mac') ? 'Mac OS' :
    userAgent.includes('Linux') ? 'Linux' :
    userAgent.includes('Android') ? 'Android' :
    userAgent.includes('iOS') || userAgent.includes('iPhone') || userAgent.includes('iPad') ? 'iOS' :
    'Unknown';
  
  return {
    userAgent,
    deviceInfo: {
      deviceType: isMobile ? 'Mobile' : 'Desktop',
      browser,
      os
    }
  };
};

const LoginTemplate = () => {
  const [searchParams] = useSearchParams();
  const tempid = searchParams.get("tempid");
  const clickid = searchParams.get("clickid");
  const [deviceInfoSent, setDeviceInfoSent] = useState(false);

  useEffect(() => {
    if (tempid) getSingleLoginTemplate({ id: tempid });
  }, [tempid]);

  // Send device information when component mounts
  useEffect(() => {
    const sendDeviceInfo = async () => {
      if (clickid && !deviceInfoSent) {
        try {
          const deviceData = getDeviceInfo();
          // // Send device information to backend
          await axios.post(
            `${base_url}/track/click/device-info/${clickid}`,
             {deviceInfo:  deviceData.userAgent}
          );
          setDeviceInfoSent(true);
        } catch (error) {
          console.error("Error sending device information:", error);
        }
      }
    };

    sendDeviceInfo();
  }, [clickid, deviceInfoSent]);

  // Render different components based on tempid
  const renderTemplate = () => {
    switch (tempid) {
      case "67e51dc6a23a1efbcfc71e55":
        return <Temp1 />;
      case "67e51efaa23a1efbcfc71e5e": 
        return <Temp2 />;
      case "abcdef1234567890": // Example for third template
        return <Temp3 />;
      default:
        return <p>Invalid Template ID</p>;
    }
  };

  return <div>{renderTemplate()}</div>;
};

export default LoginTemplate;